import client from '@/api/client'
import {
    IsScorecardTemplateResponse,
    SurveyTemplate,
    ScorecardObject,
} from '@/entities/appstore/personal-scorecard'
import { IUserType } from '@/entities/usertype'

export async function getCustomFields() {
    const response = await client.get<string[]>(`person/custom-fields`)

    return response.data
}

export async function getSurveyTemplates() {
    const response = await client.get<SurveyTemplate[]>(
        `appstore/personal-scorecard/survey-templates`
    )

    return response.data
}

export async function getIsScorecardTemplate(id: string) {
    const response = await client.get<IsScorecardTemplateResponse>(
        `appstore/personal-scorecard/is-scorecard-template/${id}`
    )

    return response.data
}

export async function getPersonalScorecardList() {
    const response = await client.get<ScorecardObject[]>(
        'appstore/personal-scorecard'
    )

    return response.data
}

export async function getConfiguration(id: string) {
    const response = await client.get<ScorecardObject>(
        `appstore/personal-scorecard/${id}`
    )

    return response.data
}

interface PostConfigurationResponse {
    success: boolean
    msg: string
    scorecard: ScorecardObject
}

export async function postConfiguration(scorecard: ScorecardObject) {
    const response = await client.post<PostConfigurationResponse>(
        `appstore/personal-scorecard/${scorecard.id}`,
        scorecard
    )

    return response.data
}

interface PostAddLangResponse {
    success: boolean
    lang: string
    id: string
}

export async function postAddLang(
    newLang: string,
    copyFrom: string,
    description = ''
) {
    const response = await client.post<PostAddLangResponse>(
        `addlang`,
        {
            newlang: newLang,
            predefinedTemplate: copyFrom,
            description: description,
        },
        {
            baseURL: `/setting/email/`,
        }
    )

    return response.data
}

interface GetBaseUserRolesResponse {
    success: boolean
    msg: string
    data: IUserType[]
}

export async function getBaseUserRoles() {
    try {
        const response = await client.get<GetBaseUserRolesResponse>(
            `user/roles/base`
        )

        return response.data
    } catch (e) {
        return { success: false, msg: 'Something went wrong.' }
    }
}

interface PostCustomFieldResponse {
    success: boolean
    msg: string
}

export async function postCustomField(customFields: string[]) {
    const response = await client.post<PostCustomFieldResponse>(
        `person/custom-fields`,
        {
            customFields,
        }
    )

    return response.data
}
